import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigResponse } from '../../../shared/interfaces/equipment.interfaces';
import { Observable } from 'rxjs';

const basePath = '/equipment/config';

@Injectable({
  providedIn: 'root'
})

export class EquipmentConfigService {

  constructor(private http: HttpClient) { }

  // sends a command to the equipment to read its configuration and send it back to the server
  readConfigFromEquipment(equipmentId: number): Observable<{ status: string }> {
    return this.http.get<{ status: string }>(`${basePath}/read/${equipmentId}`);
  }

  // gets the last known configuration of the equipment from the server
  getConfig(equipmentId: number): Observable<ConfigResponse[]> {
    return this.http.get<ConfigResponse[]>(`${basePath}/${equipmentId}`);
  }

  // sends a command to the equipment to update its configuration
  postConfig(equipmentId: number, command: string) {
    // command format: 09=key:value;key:value;...
    const body = {
      command: command
    };
    return this.http.post(`${basePath}/${equipmentId}`, body);
  }

}
